/* ============================================================
   TWO ROOMS — Flow Line Animation System (lightweight, vanilla)
   - Scroll-fill flow guide line (rendered by tr-flow-line.liquid)
   - Scroll reveal for [data-tr-reveal] / .tr-reveal
   - Hero / image parallax for [data-tr-parallax]
   - Water-press ripple + droplets on .tr-ripple
   No libraries. ~3.5 KB. Honours prefers-reduced-motion and the
   global "Enable motion" theme setting (body.tr-no-motion).

   File: assets/tr-flow.js
   Add:  {{ 'tr-flow.js' | asset_url | script_tag }}  (defer)
         OR <script src="{{ 'tr-flow.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  "use strict";

  function init() {
    var mm = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
    var reduce = mm("(prefers-reduced-motion: reduce)") || document.body.classList.contains("tr-no-motion");

    /* ---- 1. Scroll-driven work: flow-line fill + parallax (rAF throttled) ---- */
    var fill = document.querySelector(".tr-flowline__fill");
    var parallax = [].slice.call(document.querySelectorAll("[data-tr-parallax]"));
    var ticking = false;

    function frame() {
      var y = window.scrollY || window.pageYOffset || 0;
      var doc = document.documentElement;
      var max = (doc.scrollHeight - window.innerHeight) || 1;
      var p = Math.min(1, Math.max(0, y / max));
      if (fill) fill.style.height = (p * 100).toFixed(2) + "%";
      if (!reduce) {
        for (var i = 0; i < parallax.length; i++) {
          var el = parallax[i];
          var speed = parseFloat(el.getAttribute("data-tr-parallax")) || 0.16;
          var r = el.getBoundingClientRect();
          if (r.bottom > -200 && r.top < window.innerHeight + 200) {
            var rel = (r.top + r.height / 2 - window.innerHeight / 2);
            el.style.transform = "translate3d(0," + (rel * -speed).toFixed(1) + "px,0)";
          }
        }
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

    if (fill || (!reduce && parallax.length)) {
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      frame();
    }

    /* ---- 2. Scroll reveal ---- */
    var revealEls = [].slice.call(document.querySelectorAll("[data-tr-reveal], .tr-reveal"));
    if (!reduce && "IntersectionObserver" in window && revealEls.length) {
      var fired = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { fired = true; e.target.classList.add("tr-in"); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });

      var vh = window.innerHeight || 800;
      revealEls.forEach(function (el, idx) {
        // never hide what is already in view at load
        if (el.getBoundingClientRect().top <= vh * 0.9) { el.classList.add("tr-in"); return; }
        el.classList.add("tr-reveal");
        var stagger = el.getAttribute("data-tr-stagger");
        if (stagger) el.style.transitionDelay = stagger + "ms";
        io.observe(el);
      });
      // safety net — if IO never fires (host quirks), reveal everything
      setTimeout(function () {
        if (fired) return;
        document.querySelectorAll(".tr-reveal:not(.tr-in)").forEach(function (el) { el.classList.add("tr-in"); });
      }, 3500);
    } else {
      revealEls.forEach(function (el) { el.classList.add("tr-in"); });
    }

    /* ---- 3. Water-press ripple + droplets on .tr-ripple ---- */
    if (!reduce) {
      var lum = function (c) {
        var m = (c || "").match(/[\d.]+/g);
        if (!m) return 0;
        return (0.299 * +m[0] + 0.587 * +m[1] + 0.114 * +m[2]) / 255;
      };
      document.addEventListener("click", function (e) {
        var btn = e.target.closest && e.target.closest(".tr-ripple");
        if (!btn) return;
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        var light = lum(getComputedStyle(btn).backgroundColor) > 0.6;
        var ink = light ? "#0D2D29" : "#DAF4B1";

        // soft fill settling into stone
        var d = Math.max(r.width, r.height);
        var s = document.createElement("span");
        s.className = "tr-ripple-span";
        s.style.width = s.style.height = d + "px";
        s.style.left = (x - d / 2) + "px";
        s.style.top = (y - d / 2) + "px";
        btn.appendChild(s);
        setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 760);

        if (!btn.animate) return;
        // press-in
        btn.animate([{ transform: "scale(1)" }, { transform: "scale(.96)" }, { transform: "scale(1)" }],
          { duration: 300, easing: "cubic-bezier(.3,.7,.3,1)" });
        // outline ripple ring
        var ring = document.createElement("span");
        ring.style.cssText = "position:absolute;left:" + x + "px;top:" + y + "px;width:18px;height:18px;border:2px solid " + ink + ";border-radius:50%;transform:translate(-50%,-50%);pointer-events:none;z-index:3;";
        btn.appendChild(ring);
        ring.animate([
          { transform: "translate(-50%,-50%) scale(.3)", opacity: .85 },
          { transform: "translate(-50%,-50%) scale(6)", opacity: 0 }
        ], { duration: 640, easing: "cubic-bezier(.2,.7,.2,1)" }).onfinish = function () { ring.remove(); };
        // droplets
        var n = 7;
        for (var i = 0; i < n; i++) {
          var a = (i / n) * Math.PI * 2 + (Math.random() - .5) * 0.5;
          var dist = 16 + Math.random() * 26;
          var dx = Math.cos(a) * dist, dy = Math.sin(a) * dist;
          var sz = 3.5 + Math.random() * 4;
          var dot = document.createElement("span");
          dot.style.cssText = "position:absolute;left:" + x + "px;top:" + y + "px;width:" + sz + "px;height:" + sz + "px;background:" + ink + ";border-radius:50%;transform:translate(-50%,-50%);pointer-events:none;z-index:3;";
          btn.appendChild(dot);
          (function (dot, dx, dy) {
            dot.animate([
              { transform: "translate(-50%,-50%) translate(0,0) scale(1)", opacity: 1, offset: 0 },
              { opacity: 1, offset: .55 },
              { transform: "translate(-50%,-50%) translate(" + dx.toFixed(1) + "px," + (dy + 9).toFixed(1) + "px) scale(.25)", opacity: 0, offset: 1 }
            ], { duration: 520 + Math.random() * 200, easing: "cubic-bezier(.2,.6,.4,1)" }).onfinish = function () { dot.remove(); };
          })(dot, dx, dy);
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
